import './index.css';
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { initGoogleAnalytics } from "./utils/analytics";
initGoogleAnalytics();
render(<App data-id="element-209" data-mp="21a7f4rqfsvxc" />, document.getElementById("root"));